/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";

const MapPasyala = () => (
  <div css={styles} className="mapouter">
    <iframe
      id="gmap_canvas"
      src="https://maps.google.com/maps?q=life%20light%20fitness%20-%20pasyala&t=&z=17&ie=UTF8&iwloc=&output=embed"
    ></iframe>
    
  </div>
);

const styles = css`
  width: 100%;
  max-width: 50%;
  min-height: 60vh;
  iframe {
    width: 100%;
    height: 100%;
    display: block;
    border: none;
  }
  @media (max-width: 1200px) {
    max-width: 100%;
    height: 60vh;
  }
`;

export default MapPasyala;
